import { render, staticRenderFns } from "./FeedbackThankYou.vue?vue&type=template&id=76f6f71e"
import script from "./FeedbackThankYou.vue?vue&type=script&lang=js"
export * from "./FeedbackThankYou.vue?vue&type=script&lang=js"
import style0 from "./FeedbackThankYou.vue?vue&type=style&index=0&id=76f6f71e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports